export default [
    //用户交互
    {
        path: '/guanhuai',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/guanhuai.vue')
    },
    {
        path: '/paiming',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/paiming.vue')
    },
    //日清列表
    {
        path: '/riqing',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/riqing.vue')
    },
    //日清管理员列表
    {
        path: '/riqinggly',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/riqinggly.vue'),
        meta: {keepAlive:true}
    },
    {
        path: '/shijipaodong',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/shijipaodong.vue')
    },
    {
        path: '/pup',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/pup.vue')
    },
    // 日清提报
    {
        path: '/presentation',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/presentation.vue')
    },
    // 日清提报
    {
        path: '/presentation1',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/presentation1.vue')
    },
    // 日清提报
    {
        path: '/presentation2',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/presentation2.vue')
    },
    // 周计划详情
    {
        path: '/weekplan_detail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/weekplan_detail.vue')
    },
    // 新建周计划
    {
        path: '/weekplan',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/weekplan.vue')
    },
    // 一键转化需求
    {
        path: '/transforming_demand1',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/transforming_demand1.vue')
    },
    {
        path: '/transforming_demand2',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/transforming_demand2.vue')
    },
    {
        path: '/Overdueaudit',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/Overdueaudit.vue')
    },
    {
        path: '/Overduesubmit',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/Overduesubmit.vue')
    },
	{
	    path: '/submissionplan',
	    // which is lazy-loaded when the route is visited.
	    component: () => import( '@/views/guanhuai/submissionplan.vue')
	},
    //计划日清列表
    {
        path: '/dailyPlan',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/dailyPlan.vue'),
        meta: {
            title: '日清计划',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/dailyPlanDetail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/dailyPlanDetail.vue')
    },


    {
        path: '/riqingpingjia',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/riqing/riqingpingjia.vue'),
        meta: {
            title: '日清评价',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/riqingReport',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/riqing/riqingReport.vue'),
        meta: {
            title: '日清报表',
            isTabsPage: true,
            keepAlive:true
        }
    },

    {
        path: '/muBiaoMonth',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/mubiao/muBiaoMonth.vue'),
        meta: {
            title: '月目标管理',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path:'/dayPlan',
        component: () => import( '@/views/guanhuai/dayPlan/dayPlan.vue'),
        meta: {
            title: '日计划管理',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path:'/dayPlanAdd',
        component: () => import( '@/views/guanhuai/dayPlan/dayPlanAdd.vue'),
        meta: {
            title: '日清补录',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/muBiaoWeek',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/mubiao/muBiaoWeek.vue'),
        meta: {
            title: '周目标管理(体验)',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/dayClearReport',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/dayclearreport/dayClearReport.vue'),
        meta: {
            title: '日清报表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/clearAppraisal',
        component: () => import( '@/views/guanhuai/clearappraisal/clearAppraisal.vue'),
        meta: {
            title: '国内市场日清评价',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/weekCollect',
        component: () => import( '@/views/guanhuai/weekclearcollect/weekCollect.vue'),
        meta: {
            title: '周目标汇总',
            isTabsPage: true,
            keepAlive:true
        }
    },

    {
        path: '/wsdifferenceCollect',
        component: () => import( '@/views/guanhuai/wsdifferencecollect/wsdifferenceCollect.vue'),
        meta: {
            title: '周目标显差',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/bscContactPerson',
        component: () => import( '@/views/guanhuai/bsccontactperson/bscContactPerson.vue'),
        meta: {
            title: '客户联系人',
            isTabsPage: true,
            keepAlive:true
        }
    },

    //
    {
        path: '/bsccluemanage',
        component: () => import( '@/views/guanhuai/bsccluemanage/bscClueManage.vue'),
        meta: {
            title: '线索管理',
            isTabsPage: true,
        }
    },
    //新地址，防止前端菜单跳转到旧地址
    {
        path: '/bsccluemanageNew',
        component: () => import( '@/views/guanhuai/bsccluemanage/bscClueManage.vue'),
        meta: {
            title: '线索管理',
            isTabsPage: true,
        }
    },

    {
        path: '/bsccluemanagehighseas',
        component: () => import( '@/views/guanhuai/bsccluemanage/bscClueManageHighSeas.vue'),
        meta: {
            title: '线索公海',
            isTabsPage: true,
            keepAlive:true
        }
    },

    {
        path: '/bsccluereport',
        component: () => import( '@/views/guanhuai/bsccluemanage/bscClueReport.vue'),
        meta: {
            title: '线索管理统计表',
            isTabsPage: true,
            keepAlive:true
        }
    },

    {
        path: '/poorresourcedemand',
        component: () => import( '@/views/guanhuai/poorresourcedemand/poorresourcedemand.vue'),
        meta: {
            title: '资源需求显差',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/riqingpingjia',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/riqing/riqingpingjia.vue'),
        meta: {
            title: '日清评价',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/dakajilu',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/dakajilu/dakajilu.vue'),
        meta: {
            title: '打卡记录',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //创单月目标
    {
        path: '/createMonthGoal',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/mubiao/createMonthGoal.vue')
    },
    //协同管理主页面
    {
        path: '/newResourceList',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/xietongguanli/newResourceList.vue'),
        meta: {
            title: '协同问题列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //协同管理创建
    {
        path: '/newCreateResource',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/xietongguanli/newCreateResource.vue')
    },
    //协同详情
    {
        path: '/newXieTongDetails',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/xietongguanli/newXieTongDetails.vue')
    },
    //承接部门/答复人管理
    {
        path: '/deptUser',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/xietongguanli/deptUser.vue'),
        meta: {
            title: '协同部门配置',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //承接部门/答复人管理
    {
        path: '/isRiqingRep',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/riqingbaobiao/riqingbaobiao.vue'),
        meta: {
            title: '考勤报表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //周目标项目管理
    {
        path: '/dailyTargetProject',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/targetProject/dailyTargetProject.vue'),
        meta: {
            title: '项目管理',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/muBiaoWeekCk',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/mubiao/muBiaoWeekCk.vue'),
        meta: {
            title: '周目标管理(创单)',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //客戶年度目标
    {
        path: '/annualTarget',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/annualtarget/annualTarget.vue'),
        meta: {
            title: '客戶年度目标',
            isTabsPage: true,
            keepAlive:true
        }
    },
    // {
    //     path: '/battleNet',
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import( '@/views/guanhuai/battleNet/battleNet.vue')
    // },
    //周目标明细
    {
        path: '/weekSummary',
        component: () => import( '@/views/guanhuai/weekSummary/weekSummary.vue'),
        meta: {
            title: '周目标明细',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //人员配置
    {
        path:'/dayCleanConfig',
        component: () => import( '@/views/guanhuai/dayCleanConfig/dayCleanConfig.vue'),
        meta: {
            title: '人员配置',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //人员配置
    {
        path:'/newDayCleanConfig',
        component: () => import( '@/views/guanhuai/dayCleanConfig/newDayCleanConfig.vue'),
         meta: {
             title: '新人员配置管理',
                 isTabsPage: true,
                 keepAlive:true
         }
    },
    //市场行情信息反馈汇总
    {
        path: '/userMarketConditions',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/usermarketconditions/userMarketConditions.vue')
    },
    //市场行情信息反馈汇总
    {
        path: '/userResourceNeedMessage',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/guanhuai/userresourceneedmessage/userResourceNeedMessage.vue')
    },
    {
        path: '/cluesResource',
        component: () => import( '@/views/guanhuai/bsccluemanage/bscCluesResource.vue'),
        meta: {
            title: '线索来源',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/createClues',
        component: () => import( '@/views/guanhuai/bsccluemanage/createClues.vue'),
    },

    {
        path: '/clueOwnerPage',
        component: () => import( '@/views/guanhuai/wl/clueOwnerPage.vue'),
        meta: {
            title: '省区渠道负责人表',
            isTabsPage: true
        }
    },
    {
        path: '/clueDesignOwnerPage',
        component: () => import( '@/views/guanhuai/wl/clueDesignOwnerPage.vue'),
        meta: {
            title: '大项目负责人表',
            isTabsPage: true
        }
    },
    {
        path: '/clueCompanyOwnerPage',
        component: () => import( '@/views/guanhuai/wl/clueCompanyOwnerPage.vue'),
        meta: {
            title: '分公司负责人表',
            isTabsPage: true
        }
    },
    {
        path: '/clueIndustryOwnerPage',
        component: () => import( '@/views/guanhuai/wl/clueIndustryOwnerPage.vue'),
        meta: {
            title: '产业负责人及经销商表',
            isTabsPage: true
        }
    },


    {
        path: '/clueAgentOwnerPage',
        component: () => import( '@/views/guanhuai/wl/clueAgentOwnerPage.vue'),
        meta: {
            title: '经销商负责人表',
            isTabsPage: true
        }
    },


    {
        path: '/clueIndustryKeywordPage',
        component: () => import( '@/views/guanhuai/wl/clueIndustryKeywordPage.vue'),
        meta: {
            title: '线索产业关键字',
            isTabsPage: true
        }
    },


    {
        path: '/bscClueTabs',
        component: () => import( '@/views/guanhuai/bsccluezhaobiao/clueTabs.vue'),
        meta: {
            title: '线索管理',
            isTabsPage: true
        }
    },

    {
        path: '/designateClueZhaoBiao',
        component: () => import( '@/views/guanhuai/bsccluezhaobiao/designateClueZhaoBiao.vue'),
        meta: {
            title: '指派招标线索管理',
            isTabsPage: true
        }
    },

    {
        path: '/clueToProject',
        component: () => import( '@/views/guanhuai/bsccluezhaobiao/clueToProject.vue'),
        meta: {
            title: '线索转项目',
        }
    },



    {
        path: '/designateClue400',
        component: () => import( '@/views/guanhuai/bsccluezhaobiao/designateClue400.vue'),
        meta: {
            title: '400营销线索管理',
            isTabsPage: true
        }
    },

    /**线上矩阵*/
    {
        path: '/bscClueOnlineMatrixList',
        component: () => import( '@/views/guanhuai/onlineMatrix/bscClueOnlineMatrixList.vue'),
        meta: {
            title: '线上矩阵',
            isTabsPage: true,
            hot: true,
        }
    },
    {
        path: 'bscClueOnlineMatrixAdd',
        component: () => import( '@/views/guanhuai/onlineMatrix/bscClueOnlineMatrixAdd.vue'),
    },
    {
        path: '/designateOnlineMatrix',
        component: () => import( '@/views/guanhuai/onlineMatrix/designateOnlineMatrix.vue'),
        meta: {
        }
    },
    /*托盘商联系人维护*/
    {
        path: '/palletDealerPage',
        component: () => import( '@/views/guanhuai/onlineMatrix/palletDealerPage.vue'),
        meta: {
        }
    },

]
